/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled'
import React, { FC, ReactNode, memo } from 'react'
import { rpMediaQueries } from '../../core/theme'

interface RoundIconBtnProps
  extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'> {
  /** Иконка в виде React компонента */
  icon: ReactNode
  /** Обработчик клика без аргументов */
  onClick?: () => void
  /** Заблокирована ли кнопка */
  disabled?: boolean
}

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.4s ease-in-out;
`

const StyledButton = styled.button<{
  disabled: boolean
}>`
  display: flex;
  padding: 6px 10px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0);

  background: ${(p) => p.theme.rpTheme.colors.white};
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05), 0 4px 4px 0 rgba(0, 0, 0, 0.05),
    0 10px 10px 0 rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(7px);

  svg {
    color: ${(p) => p.theme.rpTheme.colors.black};
    fill: ${(p) => p.theme.rpTheme.colors.black};
  }

  ${(p) =>
    p.disabled &&
    `
    opacity: 0.27;
    cursor: not-allowed;
  `}

  ${(p) =>
    !p.disabled &&
    `
    &:hover {
      filter: brightness(0.95);

      ${IconWrapper} {
        transform: rotate(360deg);
      }
    }
  `}

  ${rpMediaQueries.tablet} {
    padding: 10px 16px;
    border-radius: 22px;
  }

  ${rpMediaQueries.desktop} {
    padding: 11px 18px;
    border-radius: 22px;
  }
`

export const RoundIconBtn: FC<RoundIconBtnProps> = memo(
  ({ icon, onClick, disabled = false, ...rest }) => {
    const handleClick = (): void => {
      if (!disabled) {
        onClick?.()
      }
    }

    return (
      <StyledButton
        type="button"
        disabled={disabled}
        onClick={handleClick}
        {...rest}>
        <IconWrapper>{icon}</IconWrapper>
      </StyledButton>
    )
  }
)
